var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AlertTable',{attrs:{"canEdit":true,"editRoute":"SuperAdminClinicEdit","createRoute":"SuperAdminClinicCreate"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }